export default __webpack_public_path__ + "beta-maps-guides-migrate-3d-terrain-960-992c029a2f6e742b6cc9c9aff429e4ce.png";